import DOMPurify from "dompurify";

/** Rich-text blocks are author-supplied and rendered to clients on public proposal pages,
 *  so every HTML string passes through DOMPurify before it ever reaches the DOM. */
const ALLOWED_TAGS = [
  "p", "br", "strong", "b", "em", "i", "u", "s", "span", "div",
  "ul", "ol", "li", "a", "h1", "h2", "h3", "h4", "h5", "h6",
  "blockquote", "code", "pre", "hr", "table", "thead", "tbody", "tr", "th", "td", "sub", "sup",
];

export const safeHtml = (html) =>
  DOMPurify.sanitize(String(html || ""), {
    ALLOWED_TAGS,
    ALLOWED_ATTR: ["href", "target", "rel", "title", "class", "colspan", "rowspan"],
    ALLOW_DATA_ATTR: false,
    FORBID_TAGS: ["script", "style", "iframe", "object", "embed", "form", "input", "svg", "math"],
    FORBID_ATTR: ["style", "srcset", "formaction", "xlink:href"],
  });
